import * as PropTypes from "prop-types";
import {calculateDays, dateToUTCTimezone} from "../common/date";

export const ResultType = PropTypes.shape({
    id: PropTypes.number,
    country_name: PropTypes.string,
    resort_name: PropTypes.string,
    resort_image: PropTypes.string,
    number_of_available_apartments: PropTypes.number,
    wheelchair_accessible: PropTypes.bool,
    period_not_defined: PropTypes.bool
});

export const SearchObjectType = {
    selectedResortsAll: PropTypes.bool,
    selectedCountries: PropTypes.array,
    selectedDestinations: PropTypes.array,
    dateFrom: PropTypes.any,
    dateTo: PropTypes.any,
    flexibleDates: PropTypes.string,
    guests: PropTypes.number,
    wheelchairAccessible: PropTypes.bool,
    highlights: PropTypes.array | PropTypes.string
};

export const initializeSearchObject = () => {
    return {
        selectedResortsAll: true,
        selectedCountries: [],
        selectedDestinations: [],
        dateFrom: undefined,
        dateTo: undefined,
        guests: 2,
        wheelchairAccessible: false,
        highlights: []
    };
};

export const getFlexibleDatesOptions = (houseboat, i18nHook, dateFrom, dateTo) => {
    let dateDiff;
    if (dateTo) {
        dateDiff = getDateDiff(dateFrom, dateTo);
    }

    return getResults(houseboat, i18nHook, dateFrom, dateTo, dateDiff);
};

export const getFirstAvailableFlexDate = (houseboat, dateFrom, dateTo) => {
    const dateDiff = getDateDiff(dateFrom, dateTo);

    if (dateDiff < 3) {
        return null;
    } else if (!houseboat && dateDiff < 6) {
        return "1-3";
    } else if (!houseboat && dateDiff < 8) {
        return "4-6";
    } else if (dateDiff >= 8) {
        return "7";
    }
    return null;
};

export const getDateDiff = (dateFrom, dateTo) => {
    return calculateDays(dateToUTCTimezone(dateFrom), dateToUTCTimezone(dateTo));
};

export const getResultFromOption = (flexibleOption, i18nHook) => {
    let option = getResults(undefined, i18nHook).filter(option => option.value === flexibleOption)[0];
    return option ? option : {label: `${flexibleOption} ${i18nHook?.i18nLowerIfRequired("common.label.nights")}`, value: flexibleOption, minNights: parseInt(flexibleOption), type: "custom"};
};


const getResults = (houseboat, i18nHook, dateFrom, dateTo, dateDiff) => {
    return [
        {label: i18nHook?.i18n("common.label.as_defined"), value: undefined, disabled: false, hidden: false},
        {label: "1-3 " + i18nHook?.i18nLowerIfRequired("common.label.nights"), value: "1-3", disabled: (dateTo ? ((houseboat) || dateDiff < 3) : true), hidden: false, minNights: 3},
        {label: "4-6 " + i18nHook?.i18nLowerIfRequired("common.label.nights"), value: "4-6", disabled: (dateTo ? ((houseboat) || dateDiff < 6) : true), hidden: false, minNights: 6},
        {label: "7 " + i18nHook?.i18nLowerIfRequired("common.label.nights"), value: "7", disabled: (dateTo ? (dateDiff < 8) : true), hidden: false, minNights: 8},
        {label: i18nHook?.i18n("common.label.weekend"), value: "weekend", disabled: (dateTo ? ((houseboat) || dateDiff < 8) : true), hidden: false, minNights: 8}
    ];
};
